import ColorPicker from "./index.vue";

export default ColorPicker;
